/* eslint-disable no-unused-vars,no-param-reassign */
/* global G, PLATFORM */
import { curry } from 'lib/util'
import session, { settings } from 'app/_shared/session'
import { redirect } from 'app/_shared/events'
import openExternalPortal from 'app/_shared/events/redirect/openExternalPortal'

/**
 * Shows a dialog informing the user that the requested operation has to be done elsewhere.
 *
 * @param {Gaia.AppModule.Spec} module
 * @returns {Promise<void>}
 */
const showExternalProfileDialog = async (module) => {
  const eventBus = module[G.ADAPTER][G.EVENTS]
  const intl = module[G.ADAPTER][G.INTL]

  eventBus.dispatch(eventBus.type(G.DATA, G.UNDO), {
    width: 'sm',
    title: await intl._t(
      'title.user.change',
      {
        ns: 'user',
        _key: 'title.user.change',
        defaultValue: 'Change password',
      },
    ),
    text: await intl._t(
      'guest.text.externalProfile',
      {
        ns: 'custom',
        _key: 'guest.text.externalProfile',
        defaultValue: '',
      },
    ),
    children: {
      ok: {
        key: 'ok',
        value: await intl._t(
          'guest.button.externalProfile',
          {
            ns: 'custom',
            _key: 'guest.button.externalProfile',
            defaultValue: 'Ok',
          },
        ),
      },
      cancel: {
        key: 'cancel',
        value: await intl._t(
          'button.cancel',
          {
            ns: 'common',
            _key: 'button.cancel',
            defaultValue: 'Cancel',
          },
        ),
      },
    },
    okHandler: async () => module[G.ADAPTER][G.ROUTER].newTab({ url: settings.externalProfileUrl }),
  })
}

/**
 * Redirect Local User Event Handler
 *
 * Redirects to the component's default route or, if the last validated account has the
 * remoteAuthentication flag and the externalPortalUrl setting is set, displays a dialog informing
 * the user that the requested operation has to be done elsewhere.
 *
 * @type {Gaia.AppModule.EventHandler}
 */
const redirectLocalUser = async (module, component, event) => {
  const model = module[G.MODEL]
  const user = model[G.CACHE]

  const { remoteAuthentication, custom } = user.value

  if ((remoteAuthentication || custom) && settings.externalProfileUrl) {
    await showExternalProfileDialog(module)
  } else {
    await redirect(module, component, event)
  }
}

export default curry(redirectLocalUser)
